import { Building, Users, CheckCircle } from "lucide-react";
import { PALETTE } from "../../styles/configStyles";

const CompanyTab = ({
  styles,
  t,
  theme,
  isRTL,
  language,
  config,
  setConfig,
  selectedCompanyName,
  detectedCompanies,
  canEditField,
  getFieldStyle,
}) => {
  const canEdit = canEditField("company");

  return (
    <div style={{marginTop: "24px", marginBottom: "24px"}}>
      <h3 style={styles.sectionTitle}>
        <div style={styles.sectionIconBadge(PALETTE.primary.base)}>
          <Building size={20} />
        </div>
        {t.company.title}
        {!canEdit && (
          <span style={{
            fontSize: "11px",
            fontWeight: "700",
            marginLeft: isRTL ? "0" : "12px",
            marginRight: isRTL ? "12px" : "0",
            padding: "4px 12px",
            borderRadius: "6px",
            background: `${PALETTE.amber.base}15`,
            color: PALETTE.amber.base,
            border: `1px solid ${PALETTE.amber.base}25`,
          }}>
            {language === "ar" ? "(للقراءة فقط)" : "(Read-only)"}
          </span>
        )}
      </h3>

      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>{t.company.companyName}</label>
          <input
            type="text"
            value={config.companyName || selectedCompanyName || t.company.notSet}
            readOnly
            style={{ ...styles.input, opacity: 0.7 }}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>{t.company.industry}</label>
          <input
            type="text"
            value={config.industry || t.company.notSet}
            onChange={(e) => canEdit && setConfig({ ...config, industry: e.target.value })}
            disabled={!canEdit}
            style={getFieldStyle("company", styles.input)}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>{t.company.email}</label>
          <input
            type="email"
            value={config.email || ""}
            onChange={(e) => canEdit && setConfig({ ...config, email: e.target.value })}
            disabled={!canEdit}
            style={getFieldStyle("company", styles.input)}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>{t.company.address}</label>
          <input
            type="text"
            value={config.address || ""}
            onChange={(e) => canEdit && setConfig({ ...config, address: e.target.value })}
            disabled={!canEdit}
            style={getFieldStyle("company", styles.input)}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>{t.company.website}</label>
          <input
            type="url"
            value={config.website || ""}
            onChange={(e) => canEdit && setConfig({ ...config, website: e.target.value })}
            disabled={!canEdit}
            style={getFieldStyle("company", styles.input)}
          />
        </div>
      </div>

      <div style={styles.statsGrid}>
        <div style={styles.statCard}>
          <div style={{ ...styles.statIconWrapper, background: `linear-gradient(135deg, ${PALETTE.primary.base}, ${PALETTE.primary.dark})` }}>
            <Users size={20} />
          </div>
          <div>
            <div style={styles.statValue}>{detectedCompanies.length || 0}</div>
            <div style={styles.statLabel}>{t.totalCompanies}</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{ ...styles.statIconWrapper, background: `linear-gradient(135deg, ${PALETTE.emerald.base}, ${PALETTE.emerald.dark})` }}>
            <CheckCircle size={20} />
          </div>
          <div>
            <div style={styles.statValue}>
              {detectedCompanies.filter((c) => c.isConfigured).length || 0}
            </div>
            <div style={styles.statLabel}>{t.configuredCompanies}</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{ ...styles.statIconWrapper, background: `linear-gradient(135deg, ${PALETTE.amber.base}, ${PALETTE.amber.dark})` }}>
            <Building size={20} />
          </div>
          <div>
            <div style={styles.statValue}>{selectedCompanyName ? 1 : 0}</div>
            <div style={styles.statLabel}>{t.selectedCompanyLabel}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyTab;